import { useLayoutEffect, RefObject } from 'react';

export function useFixedToParent(parentRef: RefObject<HTMLElement>, childRef: RefObject<HTMLElement>) {
    useLayoutEffect(() => {
        if (!parentRef.current || !childRef.current) return;

        const adjust = () => {
            const { width, left } = parentRef.current!.getBoundingClientRect();
            Object.assign(childRef.current!.style, {
                width: `${width}px`,
                left: `${left}px`,
            });
        };

        // Llamada inicial
        adjust();

        // Observador para cambios de tamaño del padre
        const ro = new ResizeObserver(adjust);
        ro.observe(parentRef.current);

        // Listeners de scroll y resize de ventana
        window.addEventListener('scroll', adjust, { passive: true });
        window.addEventListener('resize', adjust);

        return () => {
            ro.disconnect();
            window.removeEventListener('scroll', adjust);
            window.removeEventListener('resize', adjust);
        };
    }, [parentRef, childRef]);
}
